import { matchPath } from 'react-router';
import { BASE_PATH } from 'dd-cms-client/app/App';
import { ResourceName } from 'dd-cms-client/app/resources';

enum Tenant {
  DAYDEAL = 'Daydeal',
  MATCHDEAL = 'Matchdeal',
  PARTNERDEAL = 'Partnerdeal'
}

const ALL_PERMISSIONS = 'all';

const TENANT_PERMISSIONS: Record<Tenant, Array<ResourceName | typeof ALL_PERMISSIONS>> = {
  [Tenant.DAYDEAL]: [ALL_PERMISSIONS],
  [Tenant.MATCHDEAL]: [
    ResourceName.DEAL,
    ResourceName.CATEGORY,
    ResourceName.USER,
    ResourceName.USER_PROFILE,
    ResourceName.COMMENT,
  ],
  [Tenant.PARTNERDEAL]: [
    ResourceName.DEAL,
    ResourceName.THEME,
    ResourceName.APP,
    ResourceName.BAN,
    ResourceName.STICKER,
    ResourceName.CATEGORY,
    ResourceName.USER,
    ResourceName.USER_PROFILE,
    ResourceName.COMMENT,
  ],
};

enum SpecificFunctionality {
  NEWSLETTER = 'newsletter',
  STICKERS = 'stickers',
  APPS = 'apps',
  VARIANTS = 'variants',
}

const TENANT_SPECIFIC_FUNCTIONALITY: Record<Tenant, Array<SpecificFunctionality>> = {
  [Tenant.DAYDEAL]: [
    SpecificFunctionality.APPS,
    SpecificFunctionality.NEWSLETTER,
    SpecificFunctionality.STICKERS,
    SpecificFunctionality.VARIANTS,
  ],
  [Tenant.MATCHDEAL]: [
    SpecificFunctionality.VARIANTS,
  ],
  [Tenant.PARTNERDEAL]: [
    SpecificFunctionality.APPS,
    SpecificFunctionality.STICKERS,
    SpecificFunctionality.VARIANTS,
  ],
};

const DEFAULT_TENANT = Tenant.DAYDEAL;

const getTenantUrl = (tenant: Tenant): string => `/${tenant}/${ResourceName.DEAL}`;

const getTenant = (): Tenant => {
  const match = matchPath(BASE_PATH, window.location.pathname);

  return match?.params?.tenant as Tenant || DEFAULT_TENANT;
};

export {
  ALL_PERMISSIONS,
  DEFAULT_TENANT,
  getTenant,
  getTenantUrl,
  SpecificFunctionality,
  Tenant,
  TENANT_PERMISSIONS,
  TENANT_SPECIFIC_FUNCTIONALITY,
};
